// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
    formly-field-checkbox { float: left; margin-right: 5px;}
  `, "",{"version":3,"sources":["webpack://./src/app/Core/Abstract/CustomFormlyTemplate/formly-field-checkbox.ts"],"names":[],"mappings":";IACI,wBAAwB,WAAW,EAAE,iBAAiB,CAAC","sourcesContent":["\n    formly-field-checkbox { float: left; margin-right: 5px;}\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
